import { Form, Radio } from 'antd';

/** Whether the empty container's return is in the price or billed on its own — a recurring billing dispute, so a new line must answer it. */
export function EmptyReturnField({ isRequired = false }: { isRequired?: boolean }) {
  return (
    <Form.Item
      name="emptyReturnIncluded"
      label="Empty return"
      rules={isRequired ? [{ required: true, message: 'Say whether the empty return is included' }] : undefined}
    >
      <Radio.Group
        options={[
          { value: true, label: 'Included in the price' },
          { value: false, label: 'Billed separately' },
        ]}
      />
    </Form.Item>
  );
}
